import { axiosFinancial, createAuthHeaders } from "./financialApi";

export interface AutocompleteOption {
  label: string;
  value: string | number;
}

async function fetchOptions(endpoint: string, term: string, limit = 20): Promise<AutocompleteOption[]> {
  try {
    const { data } = await axiosFinancial.get(endpoint, {
      params: { 
        term, q: term, search: term, 
        businessName: term, name: term, 
        nome: term, limit 
      },
      headers: createAuthHeaders(),
    });
    
    // Suporta tanto { data: [] }, [] ou o primeiro array encontrado no objeto
    let results: any[] = [];
    if (Array.isArray(data)) {
      results = data;
    } else if (data && typeof data === 'object') {
      results = data.data || Object.values(data).find(val => Array.isArray(val)) || [];
    }

    return results.map((item: any) => {
      if (typeof item === 'string') {
        return { label: item, value: item };
      }
      return {
        label: item.label || item.nome_fantasia || item.businessName || item.name || item.nome || item.fantasy_name || item.razao_social || `ID: ${item.id}`,
        value: item.id ?? item.value ?? item.id_entidade ?? String(item),
      };
    });
  } catch (error) {
    console.error(`[global-state.service] error fetching from ${endpoint}:`, error);
    return [];
  }
}

export const searchPromotoras = (term: string, limit = 20) =>
  fetchOptions("/global-state/promotoras", term, limit);

export const searchCorbans = (term: string, limit = 20) =>
  fetchOptions("/global-state/corbans", term, limit);

export const searchGerentes = (term: string, limit = 20) =>
  fetchOptions("/global-state/gerentes", term, limit);

export const searchKamFilters = (term: string, limit = 20) =>
  fetchOptions("/global-state/kam-filters", term, limit);

export const searchFgtsB2bFilters = (term: string, limit = 20) =>
  fetchOptions("/global-state/fgts-b2b-filters", term, limit);

export const searchFgtsB2cFilters = (term: string, limit = 20) =>
  fetchOptions("/global-state/fgts-b2c-filters", term, limit);

export const searchVendedores = (term: string, limit = 20) =>
  fetchOptions("/global-state/vendedores", term, limit);
